/* eslint-disable max-len */
// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { detectIE } from 'common/utils/detect-ie';
// import { tracker } from 'common/utils/ga';
import { ROOT_ROUTE } from 'client/constants';
import Intro from 'client/components/Intro';

import faviconImg from 'assets/favicon.png';

import * as css from './App.scss';

type Props = {|
	// history: RouterHistory,
	// location: RouterLocation,
	isBusy?: boolean,
|};

type State = {
	isBusy: boolean,
};

class App extends React.PureComponent<Props, State> {
	static defaultProps = {
		isBusy: true,
	};
	async componentDidMount() {
		const isIE = detectIE();

		// tracker.init('UA-142761482-39');
		// this.props.checkAuthState();

		if (!this.props.isBusy) {
			this.removeRootPreloader();
		}

		if (document && document.body) {
			document.body.setAttribute('data-browser', isIE ? 'ie' : 'not-ie');
		}
	}

	renderHelmet = () => {
		const title = 'מתכון לחיים טובים - ynet';
		const description =
			'במסגרת פרויקט "מתכון לחיים טובים" המשותף ל"ידיעות אחרונות", ynet ואסם-נסטלה, אנחנו מזמינים צעירים בני ובנות 13 ומעלה להציע רעיונות שיעזרו לנו להקטין את ההשפעה שלנו על הסביבה באמצעות עידוד מחזור של מוצרי מזון וצמצום פסולת של אריזות מזון.';
		// Fix for whatsapp share on IOS
		//! Attention: do not import og images as variable, write path here:
		const image = '/assets/client/share.png';

		return (
			<Helmet
				title={title}
				link={[{ rel: 'icon', type: 'image/png', href: faviconImg }]}
				meta={[
					{
						name: 'description',
						content: description,
					},
					{ property: 'og:title', content: title },
					{ property: 'og:description', content: description },
					{ property: 'og:image', content: image },
				]}
			/>
		);
	};

	removeRootPreloader = () => {
		const preloadingScreen: ?HTMLElement = document.querySelector('.preloading-screen');

		if (preloadingScreen) {
			preloadingScreen.addEventListener('transitionend', (e: TransitionEvent) => {
				setTimeout(() => {
					if (document && document.body && e.target === preloadingScreen) {
						document.body.removeChild(preloadingScreen);
					}
				}, 1000);
			});
			preloadingScreen.style.opacity = '0';
			preloadingScreen.style.zIndex = '-1000';
		}
	};

	render() {
		return (
			<div id="app" className={css.app}>
				{this.renderHelmet()}
				<Switch>
					<Route exact path={ROOT_ROUTE} component={Intro} />
				</Switch>
			</div>
		);
	}
}

const mapState = (state: ClientStore) => ({
	isBusy: false,
});

const mapDispatch = {};

export default withRouter(connect(mapState, mapDispatch)(App));
